import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.8 15.362l.7.69L18 7.665l-.7-.69-8.5 8.388zm-2.8 0l9.9-9.77c.8-.79 2-.79 2.8 0l.7.69c.8.79.8 1.975 0 2.764l-9.9 9.77L6 15.362zM5 20v-2.96L8 20H5z"
    />
  </svg>
);
